module.exports = __webpack_public_path__ + "static/media/logo-vertical.a129da97.png";